import WorkAuthentication from "@/services/authentication_services/WorkAuthentication";
import store from "@/store";

export default function checkNotAuthenticated (to, from, next) {
    if (!WorkAuthentication.isAuthenticated()) {
        store.dispatch('actingUser/clearActingUserDetails');
        return next();
    }
    next('/navigation');
}
